<template>
  <div class="order-details" @click.prevent="clicked">
    <div class="left">
      <div class="order-from-restaurant">{{ orderDetails.restaurantName }}</div>
      <div class="date">{{ dateToDisplay() }}</div>
      <div class="total-price">S${{ orderDetails.totalPrice }}</div>
    </div>
    <div class="right">
      <div
        class="status-button"
        :class="{
          delivered: orderDetails.delivered,
          pending:
            orderDetails.acceptedBySaviour &&
            !orderDetails.delivered &&
            !orderDetails.cancelled,
          cancelled: orderDetails.cancelled,
          processing:
            !orderDetails.acceptedBySaviour &&
            !orderDetails.delivered &&
            !orderDetails.cancelled,
        }"
      >
        <span v-if="orderDetails.delivered">Delivered</span>
        <span
          v-else-if="
            orderDetails.acceptedBySaviour &&
              !orderDetails.delivered &&
              !orderDetails.cancelled
          "
          >Delivering</span
        >
        <span v-else-if="orderDetails.cancelled">Cancelled</span>
        <span v-else>Processing</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderViewDashboard",
  props: ["orderDetails"],
  data() {
    return {
      order: { delivered: false, acceptedBySaviour: true, cancelled: true },
      monthsOfTheYear: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {
    clicked() {
      this.$emit("see-order", this.orderDetails);
    },
    dateToDisplay() {
      const date = new Date(this.orderDetails.orderTime.toDate());
      return (
        date.getDate() +
        " " +
        this.monthsOfTheYear[date.getMonth()] +
        " " +
        date.getFullYear()
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.order-details {
  cursor: pointer;
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  background-color: #fff;
  border-radius: 8px;
  padding: 28px 32px;
  align-items: center;
  flex-direction: column;

  @media (min-width: 800px) {
    flex-direction: row;
  }

  span {
    font-size: 16px;
  }

  .left {
    display: flex;
    flex-direction: row;
    //align-items: center;

    justify-content: center;
    flex-basis: 50%;
    gap: 16px;

    .order-from-restaurant {
      flex-basis: 50%;
    }

    .date {
      flex-basis: 40%;
    }

    .total-price {
      flex-basis: 10%;
    }

    @media (min-width: 800px) {
      flex-basis: 70%;
    }
  }

  .right {
    display: flex;
    gap: 16px;
    flex-basis: 50%;

    align-items: center;
    justify-content: center;

    @media (min-width: 800px) {
      flex-basis: 30%;
    }
  }
}
// Status Button Styling
.status-button {
  display: flex;

  &::before {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
  }

  font-size: 12px;
  //margin-right: 30px;
  align-items: center;
  padding: 8px 30px;
  border-radius: 10px;
}

.delivered {
  &::before {
    background-color: #33d69f;
  }

  color: #33d69f;
  background-color: rgba(51, 214, 160, 0.1);
}

.pending {
  &::before {
    background-color: #ff8f00;
  }

  color: #ff8f00;
  background-color: rgba(255, 145, 0, 0.1);
}

.cancelled {
  &::before {
    background-color: rgb(255, 0, 60);
  }

  color: rgb(255, 0, 60);
  background-color: rgba(255, 0, 60, 0.1);
}

.processing {
  &::before {
    background-color: #1e2139;
  }

  color: #1e2139;
  background-color: rgba(30, 33, 57, 0.1);
}
</style>
